import request from '../../shared/request'

export function getOpenRequests() {
  return request('/scheduled_deliveries/open_requests')
}

export function addScheduledDelivery(payload) {
  return request(`/scheduled_deliveries`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getScheduledDeliveries() {
  return request(`/scheduled_deliveries`)
}

export function getScheduledDeliveryById(scheduledDeliveryId) {
  return request(`/scheduled_deliveries/${scheduledDeliveryId}`)
}

export function scheduledDeliveryUpdate(payload) {
  return request(`/scheduled_deliveries/${payload.scheduledDeliveryId}`, {
    method: 'PUT',
    body: { scheduledDeliveryDetails: payload.scheduledDeliveryDetails, items: payload.items },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteScheduledDelivery(scheduledDeliveryId) {
  return request(`/scheduled_deliveries/${scheduledDeliveryId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateScheduledDeliveryItems(items) {
  return request(`/scheduled_deliveries/items`, {
    method: 'PUT',
    body: { items: items },
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/scheduledDeliveries.js